<template>
  <!-- 订单详情 -->
  <div class="orderDetails" v-if="dialogVisible">
    <el-dialog
      width="92%"
      custom-class="order-dialog"
      :visible.sync="dialogVisible"
      @close="$emit('update:visible', false)"
    >
      <div slot="title" class="order-dialog__title">
        <div class="order-dialog__title-main">
          <i
            v-if="detailsData.backStatus"
            class="iconfont icon-fan order-dialog__back-icon"
          ></i>
          <span class="order-dialog__sn">{{ detailsData.orderSn || "订单详情" }}</span>
          <el-tag
            v-if="detailsData.status !== undefined && detailsData.status !== null"
            size="small"
            effect="plain"
            class="order-dialog__status-tag"
          >
            {{ orderStatus(detailsData.status) }}
          </el-tag>
          <el-tag v-if="detailsData.channelName" size="small" type="info" effect="plain">
            {{ detailsData.channelName }}
          </el-tag>
        </div>
      </div>

      <div class="order-detail-body">
        <!-- 顶部摘要 -->
        <div class="order-summary">
          <div class="order-summary__item">
            <span class="order-summary__label">实付金额</span>
            <span class="order-summary__value order-summary__value--primary">
              ¥{{ detailsData.payAmount != null ? detailsData.payAmount : "0.00" }}
            </span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">下单衣物</span>
            <span class="order-summary__value">{{ detailsData.itemQuantity || 0 }} 件</span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">实际衣物</span>
            <span class="order-summary__value">{{ detailsData.itemRealityQuantity || 0 }} 件</span>
          </div>
          <div class="order-summary__item">
            <span class="order-summary__label">用户号码</span>
            <span class="order-summary__value">{{ detailsData.phone || "-" }}</span>
          </div>
        </div>

        <!-- 基本信息卡片 -->
        <div class="detail-cards">
          <section class="detail-section">
            <div class="detail-section__head">
              <i class="el-icon-document detail-section__icon"></i>
              <h3 class="detail-section__title">订单信息</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="3" size="small" border>
                <el-descriptions-item label="支付方式">
                  <el-tag type="success" size="mini" v-if="detailsData.payType == '1'">微信</el-tag>
                  <el-tag type="danger" size="mini" v-else-if="detailsData.payType == '0'">未支付</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="下单时间">{{ detailsData.payTime || "-" }}</el-descriptions-item>
                <el-descriptions-item label="预约时间">{{ detailsData.beginTime || "-" }}</el-descriptions-item>
                <el-descriptions-item v-if="detailsData.backStatus" label="返洗关联主单">
                  {{ detailsData.parentOrderSn }}
                </el-descriptions-item>
                <el-descriptions-item label="订单备注" :span="detailsData.backStatus ? 2 : 3">
                  <el-tooltip
                    v-if="detailsData.note"
                    :content="detailsData.note"
                    placement="top"
                    effect="dark"
                    :disabled="isContentShort(detailsData.note)"
                  >
                    <div class="ellipsis">{{ detailsData.note }}</div>
                  </el-tooltip>
                  <span v-else>-</span>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <section class="detail-section">
            <div class="detail-section__head">
              <i class="el-icon-money detail-section__icon detail-section__icon--money"></i>
              <h3 class="detail-section__title">金额明细</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="3" size="small" border>
                <el-descriptions-item label="微信支付">
                  {{ detailsData.wxAmount != null ? detailsData.wxAmount : 0 }}
                </el-descriptions-item>
                <el-descriptions-item label="余额支付">
                  {{ detailsData.balancelAmount != null ? detailsData.balancelAmount : 0 }}
                </el-descriptions-item>
                <el-descriptions-item label="实付金额">{{ detailsData.payAmount || 0 }}</el-descriptions-item>
                <el-descriptions-item label="市场金额">{{ detailsData.originalAmount || 0 }}</el-descriptions-item>
                <el-descriptions-item label="运费">{{ detailsData.postage != null ? detailsData.postage : "-" }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </section>

          <section class="detail-section detail-section--full">
            <div class="detail-section__head">
              <i class="el-icon-truck detail-section__icon detail-section__icon--logistics"></i>
              <h3 class="detail-section__title">物流与生产</h3>
            </div>
            <div class="detail-section__body">
              <el-descriptions :column="3" size="small" border>
                <el-descriptions-item label="取件运单号">
                  <el-link
                    v-if="detailsData.deliverySn"
                    :underline="false"
                    type="primary"
                    @click="expressDetail(detailsData.orderSn)"
                  >
                    {{ detailsData.deliverySn }}
                  </el-link>
                  <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="送回运单号">
                  <el-link
                    v-if="detailsData.backDeliverySn"
                    :underline="false"
                    type="primary"
                    @click="expressBackDetail(detailsData.backOrderSn)"
                  >
                    {{ detailsData.backDeliverySn }}
                  </el-link>
                  <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="分检时间">{{ detailsData.sortingTime || "-" }}</el-descriptions-item>
                <el-descriptions-item label="总检时间">{{ detailsData.totalSelectionTime || "-" }}</el-descriptions-item>
                <el-descriptions-item label="出厂时间">{{ detailsData.exFactoryTime || "-" }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </section>
        </div>

        <el-tabs class="order-tabs" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="衣物信息" name="0">
            <div class="tab-panel">
              <div class="tab-panel__toolbar">
                <span class="grillage-tag">
                  <i class="el-icon-box"></i>
                  主格架号：{{ detailsData.grillage || "-" }}
                </span>
                <span v-if="detailsData.annexGrillage" class="grillage-tag grillage-tag--annex">
                  附格架号：{{ detailsData.annexGrillage }}
                </span>
              </div>
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column type="index" width="50" label="编号"></el-table-column>
              <el-table-column prop="washingCode" label="水洗码" width="180">
                <template slot-scope="scope">
                  <div style="display: flex;
    align-items: center;
    justify-content: center;">
                    <i
                      style="color:red;font-size:20px"
                      v-if="scope.row.backStatus == 1"
                      class="iconfont icon-fan"
                    ></i>
                    <i
                      style="color:red;font-size:20px"
                      v-if="scope.row.refundType == 1"
                      class="iconfont icon-tuiyuan"
                    ></i>
                    <p>{{scope.row.washingCode}}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="productName" label="衣物名称"></el-table-column>
              <el-table-column label="衣物图片" width="100">
                <template slot-scope="scope">
                  <img
                    @click="imgClick(scope.row)"
                    width="80px"
                    height="60px"
                    :style="scope.row.productPic?'display:block':'display:none'"
                    :src="scope.row.productPic"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <el-tag type="info" v-if="scope.row.status == '0'">未入厂</el-tag>
                  <el-tag type="primary" v-if="scope.row.status == '1'">已入厂</el-tag>
                  <el-tag type="warning" v-else-if="scope.row.status == '2'">已分检</el-tag>
                  <el-tag type="success" v-else-if="scope.row.status == '3'">已总检</el-tag>
                  <el-tag type="success" v-else-if="scope.row.status == '4'">已出厂</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="附件" width="180">
                <template slot-scope="scope">
                  <p
                    v-for="(item,index) in scope.row.omsOrderItemDetails"
                    :key="index"
                    :style="item.status==3?'color:#67c23a':'color:red'"
                  >{{`${scope.row.productAnnex.split(',')[index]}${item.washingCode}(${item.status!=3?'未总检':'已总检'})`}}</p>
                </template>
              </el-table-column>
              <el-table-column label="瑕疵" prop="productFlaw" width="150"></el-table-column>
              <el-table-column label="是否退洗" width="120">
                <template slot-scope="scope">
                  <el-switch
                    @change="handleRefundTypeStatusChange(scope.row)"
                    :active-value="1"
                    :inactive-value="0"
                    inactive-text="退洗:"
                    v-model="scope.row.refundType"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="sortingUserName" label="分检员" width="120"></el-table-column>
              <el-table-column prop="sortingTime" label="分检时间" width="180"></el-table-column>
              <el-table-column prop="giUserName" label="总检员" width="120"></el-table-column>
              <el-table-column prop="giTime" label="总检时间" width="180"></el-table-column>
              <el-table-column prop="exFactoryTime" label="出厂时间" width="180"></el-table-column>
              <!-- 循环渲染 -->
              <!-- <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="
                    (editCateDialogVisible = true),
                      handleEditClothing(scope.row)
                  "
                  type="primary"
                >编辑</el-button>
              </template>
              </el-table-column>-->
            </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="用户信息" name="1">
            <div class="tab-panel">
              <div class="address-cards">
                <section class="address-card">
                  <div class="address-card__head">
                    <i class="el-icon-location-outline"></i>
                    取货地址
                  </div>
                  <div class="address-card__body">
                    <p><span class="address-card__label">联系人</span>{{ detailsData.senderName || "-" }}</p>
                    <p><span class="address-card__label">电话</span>{{ detailsData.senderPhone || "-" }}</p>
                    <p class="address-card__addr">
                      {{ detailsData.senderProvince }}{{ detailsData.senderCity }}{{ detailsData.senderRegion }}{{ detailsData.senderDetailAddr }}
                    </p>
                  </div>
                </section>
                <section class="address-card">
                  <div class="address-card__head address-card__head--return">
                    <i class="el-icon-map-location"></i>
                    寄回地址
                  </div>
                  <div class="address-card__body">
                    <p><span class="address-card__label">联系人</span>{{ detailsData.receiverName || "-" }}</p>
                    <p><span class="address-card__label">电话</span>{{ detailsData.receiverPhone || "-" }}</p>
                    <p class="address-card__addr">
                      {{ detailsData.receiverProvince }}{{ detailsData.receiverCity }}{{ detailsData.receiverRegion }}{{ detailsData.receiverDetailAddr }}
                    </p>
                  </div>
                </section>
              </div>
              <div class="detail-btn">
              <el-button type="primary" size="small" @click="handleOrderNote">修改备注</el-button>
              <el-button
                v-if="isBlockAddr"
                type="primary"
                size="small"
                @click="dialogVisibleAddr = true"
              >修改寄回地址</el-button>
              <el-button
                size="small"
                type="primary"
                @click="openCreateSenderDialog(detailsData)"
                v-if="canCreateSenderOrder"
              >创建取件快递</el-button>
              <el-button
                size="small"
                type="warning"
                :loading="createReceiveLoading"
                @click="handleCreateReceive(detailsData)"
                v-if="canCreateReceiveOrder"
              >创建送回快递</el-button>
              <el-button
                v-if="isMeituanOrder && isServeMt"
                size="small"
                @click="handleServeMt"
                type="warning"
              >提交美团服务完成</el-button>
              <el-button
                v-if="isMeituanOrder && isRefundMt"
                size="small"
                @click="handleMt"
                type="warning"
              >美团商家取消预约</el-button>
              <el-button
                v-if="isMeituanOrder"
                size="small"
                @click="handleMtOrder(detailsData.channelOrderId)"
                type="warning"
              >美团订单进度查询</el-button>
              <!-- 其他渠道修改订单完成 -->
              <el-tooltip content="只完成除第三方平台来的订单" placement="top" effect="light">
                <el-button
                  v-if="detailsData.channelName!='美团' && detailsData.status<12"
                  type="success"
                  size="small"
                  @click="handleChannelWC"
                >提交订单完成</el-button>
              </el-tooltip>
              <el-button
                  v-if="isBackWash && detailsData.status<2"
                  type="success"
                  size="small"
                  @click="handleChannelQX"
                >取消返洗订单</el-button>
              <!-- 返洗 -->
              <el-button v-if="isBackWash" type="warning" size="small" @click="handleBackWash">返洗</el-button>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="商品信息" name="2">
            <div class="tab-panel">
            <!-- 小程序 -->
            <el-table
              v-if="detailsData.channelName!='美团'"
              :data="productTable"
              style="width: 100%"
              tooltip-effect="dark"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column prop="productId" label="商品ID" width="100"></el-table-column>
              <el-table-column prop="productCategory" label="商品分类"></el-table-column>
              <el-table-column prop="productName" label="商品名称"></el-table-column>
              <el-table-column label="商品图片">
                <template slot-scope="scope">
                  <img width="80px" height="60px" :src="scope.row.productPic" />
                </template>
              </el-table-column>
              <el-table-column label="分项服务">
                <template slot-scope="scope">
                  <el-tag
                    type="success"
                    v-for="(service,sIndex) in getServiceIds(scope.row.addService)"
                    :key="sIndex"
                  >{{`${service.name}￥${service.price.toFixed(2)}`}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="addServiceAmount" label="服务价格"></el-table-column>
              <el-table-column prop="originalAmount" label="市场价格"></el-table-column>
              <el-table-column prop="memberAmount" label="专属价格"></el-table-column>
              <!-- <el-table-column prop="payAmount" label="实付价格"></el-table-column> -->
              <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
            </el-table>
            <!-- 美团 -->
            <el-table
              v-else-if="detailsData.channelName=='美团'"
              :data="productTableMt"
              style="width: 100%"
              tooltip-effect="dark"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column type="index" width="50" label="#"></el-table-column>
              <el-table-column prop="id" label="商品ID" width="100"></el-table-column>
              <el-table-column prop="productCategoryName" label="商品分类"></el-table-column>
              <el-table-column prop="productName" label="商品名称"></el-table-column>
              <el-table-column label="商品图片">
                <template slot-scope="scope">
                  <img width="80px" height="60px" :src="scope.row.productPic" />
                </template>
              </el-table-column>
              <el-table-column prop="price" label="价格"></el-table-column>
              <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
            </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工单信息" name="3">
            <div class="tab-panel">
            <el-table
              :data="workTableData"
              style="width: 100%"
              tooltip-effect="dark"
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column type="index" width="50" label="#"></el-table-column>
              <el-table-column prop="orderSn" label="订单编号" width="160"></el-table-column>
              <!-- <el-table-column prop="washingCode" label="水洗码" width="150"></el-table-column> -->
              <el-table-column label="工单类型">
                <template slot-scope="scope">
                  <div>{{ workOrderStatus(scope.row.workType) }}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column> -->
              <el-table-column prop="promoterMan" label="发起人员" width="120"></el-table-column>
              <el-table-column label="优先级">
                <template slot-scope="scope">
                  <el-tag type="primary" v-if="scope.row.priority == '1'">普通</el-tag>
                  <el-tag type="danger" v-else-if="scope.row.priority == '2'">紧急</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="申请状态">
                <template slot-scope="scope">
                  <el-tag type="primary" v-if="scope.row.status == '0'">待处理</el-tag>
                  <el-tag type="success" v-else-if="scope.row.status == '2'">已完成</el-tag>
                  <el-tag type="danger" v-else-if="scope.row.status == '3'">已拒绝</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="handleMan" label="处理人员" width="120"></el-table-column>
              <el-table-column prop="modifyTime" label="修改时间" width="180"></el-table-column>
              <el-table-column
                prop="handleNote"
                label="处理备注"
                width="150"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.row)" type="primary">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="工厂信息" name="4">
            <div class="tab-panel">
            <el-descriptions class="margin-top" :column="2" size="small" border>
              <el-descriptions-item label="工厂ID">
                {{
                detailsData.factoryId
                }}
              </el-descriptions-item>
              <el-descriptions-item label="工厂名称">
                {{
                detailsData.factoryName
                }}
              </el-descriptions-item>
              <el-descriptions-item label="工厂电话">
                {{
                detailsData.factoryPhone
                }}
              </el-descriptions-item>
              <el-descriptions-item label="邮编">
                {{
                detailsData.factoryPostCode
                }}
              </el-descriptions-item>
              <el-descriptions-item label="收货地址">
                {{
                detailsData.factoryProvince +
                detailsData.factoryCity +
                detailsData.factoryRegion +
                detailsData.factoryDetailAddr
                }}
              </el-descriptions-item>
            </el-descriptions>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 修改预约时间弹出框 -->
      <!-- <el-dialog
      class="begin-dialog"
      title="修改预约时间"
      :visible.sync="dialogVisibleTime"
      width="30%"
      style="margin-top:20vh"
      center
    >
      <el-form :model="detailsData" ref="orderTimeRef" label-width="100px" size="small">
        <el-form-item label="预约时间:" prop="beginTime">
          <el-date-picker
            v-model="beginTimeMt"
            :picker-options="pickerOptions1"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTime = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogTime" size="small">确 定</el-button>
      </span>
      </el-dialog>-->
    </el-dialog>
    <!-- 大图预览 -->
    <div class="modal" v-if="showViewer">
      <el-image-viewer :on-close="closeViewer" :url-list="srcList" style="z-index:9999"></el-image-viewer>
    </div>
    <!-- 物流状态弹框 -->
    <el-drawer title="物流轨迹" :visible.sync="drawer" :before-close="handleClose">
      <el-timeline :reverse="true">
        <el-timeline-item
          v-for="(activity, index) in preDetail"
          :key="index"
          :timestamp="activity.expressTime"
        >{{ activity.expressInfo + `${activity.opCode==0&&activity.empPhone?'【电话:'+activity.empPhone+'】':''}`}}</el-timeline-item>
      </el-timeline>
    </el-drawer>
    <!-- 美团订单状态同步弹框 -->
    <el-drawer title="美团订单信息" :visible.sync="drawerQueryMt" :before-close="handleCloseQuery">
      <el-descriptions class="margin-top" title="美团订单进度" :column="1">
        <el-descriptions-item label="美团店名">{{mtInfoData.shopName}}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{mtInfoData.productName}}</el-descriptions-item>
        <el-descriptions-item label="主状态">{{ mtStatus(mtInfoData.status) }}</el-descriptions-item>
        <el-descriptions-item label="履约状态">{{ mtOrderStatus(mtInfoData.fulfilStatus) }}</el-descriptions-item>
        <template slot="extra">
          <el-button type="primary" size="small" @click="orderInfoMt(mtInfoData)">美团同步进度</el-button>
        </template>
      </el-descriptions>
    </el-drawer>
    <!-- 修改地址弹框子组件 -->
    <AddrUpdate
      :visible.sync="dialogVisibleAddr"
      :my-order="detailsData"
      @refreshList="refreshParentOrder"
    ></AddrUpdate>
    <!-- 返洗弹框子组件 -->
    <WashOrder
      :visible.sync="dialogVisibleWashOrder"
      :order-wash="detailsData"
      :clothData="tableData"
    ></WashOrder>
    <!-- 修改备注弹框 -->
    <el-dialog
      custom-class="custom-begin-dialog"
      title="修改订单备注"
      :visible.sync="dialogVisibleNote"
      width="30%"
      center
    >
      <el-form :model="detailsData" ref="orderNoteRef" label-width="80px" size="small">
        <el-form-item label="订单备注:" prop="note">
          <el-input type="textarea" :rows="5" v-model="orderNote"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleNote = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogNote" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 创建取件快递 -->
    <el-dialog
      title="创建取件快递"
      :visible.sync="dialogVisibleCreateSender"
      width="420px"
      append-to-body
      center
    >
      <el-form label-width="100px" size="small">
        <el-form-item label="预约取件时间">
          <el-date-picker
            v-model="createSenderBeginTime"
            type="datetime"
            placeholder="选填，不填则使用原预约时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisibleCreateSender = false">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="createSenderLoading"
          @click="submitCreateSender"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 工单 -->
    <WorkDetail :visible.sync="workDialogVisible" :my-work="workObj"></WorkDetail>
  </div>
</template>

<script>
// 订单号获取订单子项、工单列表(不分页)、寄出物流状态、寄出物流轨迹、寄回物流轨迹、寄回物流状态、订单号查询商品信息、订单修改、美团提前完成订单、通过订单号查询订单
import {
  orderItem,
  orderWorkBy,
  expressStatus,
  expressDetail,
  expressBackDetail,
  expressBackStatus,
  orderProduct,
  updateOrder,
  advanceOrder,
  getOrderSn
} from "@/api/order.js";
import { createSenderOrder, createReceiveOrder } from "@/api/omsOrder.js";
// 美团商家取消订单、新版取消预约、美团预约订单信息查询、美团同步订单
import {
  cancelOrderMt,
  cancelOrderMtNew,
  reserveOrderQueryMt,
  synOrderInfoMt
} from "@/api/express.js";
// 衣物列举图片、衣物修改
import { listFile, updateOrderItem } from "@/api/product.js";
// ID获取渠道商品
import { getProductIdChannelRel } from "@/api/commodity.js";
// 修改寄回地址弹框
import AddrUpdate from "@/components/address/AddressUpdate.vue";
// 返洗弹框
import WashOrder from "@/components/order/WashingOrder.vue";
// 处理工单弹出框
import WorkDetail from "@/components/order/WorkDetail.vue";
export default {
  name: "OrderDetails",
  components: {
    AddrUpdate,
    WashOrder,
    WorkDetail,
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer.vue")
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 传整个订单对象
    myOrder: {
      type: Object,
      default: () => ({})
    },
    selectList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // tab切换类型
      activeName: "",
      dialogVisible: this.visible,
      // 订单
      detailsData: this.myOrder,
      // 小程序商品信息
      productTable: [],
      // 美团商品信息
      productTableMt: [],
      // 衣物信息
      tableData: [],
      // 工单信息
      workTableData: [],
      workObj: {}, //工单处理对象
      workDialogVisible: false,
      // 控制物流状态右侧弹框
      drawer: false,
      drawerQueryMt: false, //控制美团订单查询弹框
      // 物流状态
      preStatue: "",
      // 物流轨迹
      preDetail: [],
      mtInfoData: {}, //美团订单信息
      // 大图预览列表
      showViewer: false,
      srcList: [],
      isBlockAddr: false, //是否显示修改寄回地址按钮
      isRefundMt: false, //是否显示美团商家退款按钮
      isServeMt: false, //是否显示提交美团服务完成按钮
      isBackWash: false, //是否显示返洗按钮
      // 修改地址弹框
      dialogVisibleAddr: false,
      // 修改预约时间弹出框
      // dialogVisibleTime: false,
      // beginTimeMt: new Date(),
      // 修改备注弹框
      dialogVisibleNote: false,
      orderNote: "", //订单备注
      //日期选择器配置
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 返洗下单弹出框
      dialogVisibleWashOrder: false,
      serviceList: [],
      dialogVisibleCreateSender: false,
      createSenderBeginTime: "",
      createSenderLoading: false,
      createReceiveLoading: false
    };
  },
  computed: {
    isMeituanOrder() {
      return this.detailsData && this.detailsData.channelName === "美团";
    },
    // 待取件(status=1)之前：已付款
    canCreateSenderOrder() {
      const status = Number(this.detailsData.status);
      return !this.detailsData.deliverySn && status < 1;
    },
    // 已入厂(5) ~ 已出厂(8)之前：已入厂、已分检、已总检
    canCreateReceiveOrder() {
      const status = Number(this.detailsData.status);
      return !this.detailsData.backDeliverySn && status >= 5 && status < 8;
    }
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      this.detailsData = this.myOrder;
      this.serviceList = this.selectList;
      // 如果弹框关闭所有数据都要清空
      if (!newValue) {
        this.tableData = [];
        this.resetActionFlags();
        this.$emit("refreshOrder", true);
      } else {
        this.resetActionFlags();
        // this.beginTimeMt = new Date(this.myOrder.beginTime);
        if (this.detailsData.status < 8 || this.detailsData.status == 13) {
          this.expressStatus(this.detailsData.orderSn);
        } else {
          this.expressBackStatus(this.detailsData.backOrderSn);
        }
        // 判断是否显示寄回修改地址按钮
        if (this.detailsData.status < 8) {
          this.isBlockAddr = true;
        }
        // 美团订单才显示美团商家退款(不是返洗单)
        if (
          this.detailsData.status <= 1 &&
          this.detailsData.channelName == "美团" &&
          this.detailsData.backStatus != 1
        ) {
          this.isRefundMt = true;
        }
        // 美团显示提交美团服务
        if (
          this.detailsData.status <= 12 &&
          this.detailsData.channelName == "美团" &&
          this.detailsData.backStatus != 1
        ) {
          this.isServeMt = true;
        }
        // 返洗单不显示返洗按钮，状态完成才显示按钮
        if (this.detailsData.status == 12 && this.detailsData.backStatus != 1) {
          this.isBackWash = true;
        }
        setTimeout(() => {
          // 查询衣物
          this.getOrderItem(this.detailsData.orderSn);
          // 查询工单
          this.getOrderWork(this.detailsData.orderSn);
          // 订单号查询商品信息美团是根据商品ID查商品，小程序根据订单号查商品
          this.getOrderProduct(this.detailsData);
        }, 1000);
        // this.getExpress(this.detailsData.orderSn)
        console.log(this.detailsData);
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    resetActionFlags() {
      this.isBlockAddr = false;
      this.isRefundMt = false;
      this.isServeMt = false;
      this.isBackWash = false;
    },
    // tab栏切换
    handleClick() {
      console.log('tab',this.activeName);
      
      this.$nextTick(() => {
        if (this.activeName == "0") {
          // 查询衣物
          this.getOrderItem(this.detailsData.orderSn);
        } 
      });
    },
    // 衣物列表
    async getOrderItem(orderSn) {
      this.tableData = [];
      const { data: res } = await orderItem(orderSn);
      if (res.code === 200) {
        this.tableData = res.data;
        console.log("衣物", this.tableData);
      }
      // return this.$message.error("获取衣物信息失败！");
    },
    // 是否返洗开关
    handleRefundTypeStatusChange(row) {
      this.$confirm("是否退洗该衣物?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.getUpdateOderItem(row, true);
        })
        .catch(() => {
          this.$message.info("已取消退洗!");
          this.getOrderItem(row.orderSn);
        });
    },
    // 修改子订单衣物状态
    getUpdateOderItem(data, isRefund) {
      updateOrderItem(data).then(res => {
        if (res.data.code === 200) {
          if (isRefund) {
            this.$message.success("退洗成功！");
            this.getOrderItem(data.orderSn);
          }
        }
      });
    },
    // 工单
    async getOrderWork(orderSn) {
      this.workTableData = [];
      const { data: res } = await orderWorkBy(orderSn);
      if (res.code === 200) {
        this.workTableData = res.data;
      }
      // return this.$message.error("获取工单信息失败！");
    },
    // 商品
    async getOrderProduct(data) {
      this.productTable = [];
      this.productTableMt = [];
      if (data.channelName == "美团") {
        const { data: res } = await getProductIdChannelRel(data.productId);
        if (res.code === 200) {
          this.productTableMt.push(res.data);
        }
      } else {
        const { data: res } = await orderProduct(data.paySn);
        if (res.code === 200) {
          this.productTable = res.data;
        }
      }
      console.log("dataid", data);
    },
    // 通过订单号获取寄出物流状态
    async expressStatus(orderSn) {
      this.preStatue = "";
      const { data: res } = await expressStatus(orderSn);
      if (res.code === 200 && res.data != null) {
        let arr = res.data;
        this.preStatue = arr.expressInfo;
      }
    },
    // 通过订单号获取寄出物流轨迹
    async expressDetail(orderSn) {
      this.drawer = true;
      this.preDetail = [];
      const { data: res } = await expressDetail(orderSn);
      if (res.code === 200 && res.data != null) {
        let arr = res.data.length;
        if (arr != 0) {
          this.preDetail = res.data;
        } else {
          this.preDetail = [];
        }
      }
    },
    // 通过订单号获取寄回物流状态
    async expressBackStatus(backOrderSn) {
      this.preStatue = "";
      const { data: res } = await expressBackStatus(backOrderSn);
      if (res.code === 200 && res.data != null) {
        let arr = res.data;
        this.preStatue = arr.expressInfo;
      }
    },
    // 通过订单号获取寄回物流轨迹
    async expressBackDetail(backOrderSn) {
      this.drawer = true;
      this.preDetail = [];
      const { data: res } = await expressBackDetail(backOrderSn);
      if (res.code === 200 && res.data != null) {
        let arr = res.data.length;
        if (arr != 0) {
          this.preDetail = res.data;
        } else {
          this.preDetail = [];
        }
      }
    },
    // 在状态待取货小于1且是美团订单时才能编辑修改预约时间
    handleMt() {
      let data = JSON.parse(JSON.stringify(this.detailsData));
      this.$confirm("请确定是否进行美团商家取消预约操作!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          cancelOrderMtNew(data)
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功!"
                });
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
      console.log("美团商家退款", data);
    },
    // 提交美团完成服务
    handleServeMt() {
      let data = JSON.parse(JSON.stringify(this.detailsData));
      // data.status = 12;
      this.$confirm("请确定是否提前完成美团订单服务操作!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          advanceOrder(data).then(res => {
            if (res.data.code === 200) {
              this.$message.success("提交美团完成服务成功！");
            }
          });
          console.log("提交美团完成服务", data);
        })
        .catch(() => {});
    },
    handleMtOrder(orderIds) {
      this.drawerQueryMt = true;
      this.getMtOrder(orderIds);
    },
    // 获取美团订单信息
    getMtOrder(orderIds) {
      reserveOrderQueryMt(orderIds).then(res => {
        if (res.data.code === 200) {
          this.mtInfoData = res.data.data[0];
        }
      });
    },
    // 美团同步进度
    orderInfoMt(data) {
      let obj = {
        fulfilStatus: data.fulfilStatus,
        orderId: this.detailsData.orderSn
      };
      this.$confirm("请确定是否美团同步订单操作!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          synOrderInfoMt(obj).then(res => {
            if (res.data.code === 200) {
              this.$message.success("美团同步订单成功！");
              this.getMtOrder(orderIds);
            }
          });
          console.log("美团同步订单", data, obj);
        })
        .catch(() => {});
    },
    // 修改备注按钮
    handleOrderNote() {
      this.orderNote = this.detailsData.note;
      this.dialogVisibleNote = true;
    },
    openCreateSenderDialog(order) {
      this.createSenderBeginTime = (order && order.beginTime) || "";
      this.dialogVisibleCreateSender = true;
    },
    async submitCreateSender() {
      if (!this.detailsData.id) {
        return this.$message.error("订单ID缺失");
      }
      this.createSenderLoading = true;
      try {
        const payload = { id: this.detailsData.id };
        if (this.createSenderBeginTime) {
          payload.beginTime = this.createSenderBeginTime;
        }
        const { data: res } = await createSenderOrder(payload);
        if (res.code === 200) {
          this.$message.success("创建取件快递成功");
          this.dialogVisibleCreateSender = false;
          await this.refreshOrderDetail();
        } else {
          this.$message.error(res.message || "创建取件快递失败");
        }
      } catch (e) {
        this.$message.error("创建取件快递失败");
      } finally {
        this.createSenderLoading = false;
      }
    },
    handleCreateReceive(order) {
      if (!order || !order.id) {
        return this.$message.error("订单ID缺失");
      }
      this.$confirm("确定创建送回快递吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.createReceiveLoading = true;
          try {
            const { data: res } = await createReceiveOrder({ id: order.id });
            if (res.code === 200) {
              this.$message.success("创建送回快递成功");
              await this.refreshOrderDetail();
            } else {
              this.$message.error(res.message || "创建送回快递失败");
            }
          } catch (e) {
            this.$message.error("创建送回快递失败");
          } finally {
            this.createReceiveLoading = false;
          }
        })
        .catch(() => {});
    },
    async refreshOrderDetail() {
      if (!this.detailsData.orderSn) {
        return;
      }
      const { data: res } = await getOrderSn(this.detailsData.orderSn);
      if (res.code === 200 && res.data) {
        this.detailsData = res.data;
      }
    },
    // 修改订单备注弹窗确认按钮
    handleDialogNote() {
      let data = JSON.parse(JSON.stringify(this.detailsData));
      data.note = this.orderNote;
      this.getUpdateOrder(data, true);
      this.dialogVisibleNote = false;
      console.log("note", data);
    },
    // 修改订单备注方法
    getUpdateOrder(data, isTrue) {
      updateOrder(data).then(res => {
        if (res.data.code === 200) {
          this.detailsData = res.data.data;
          if (isTrue) {
            this.$message.success("订单备注修改成功！");
          } else {
            this.$message.success("订单服务完成！");
            // 循环修改子订单衣物
            let list = JSON.parse(JSON.stringify(this.tableData));
            list.forEach(item => {
              item.status = 4;
              this.getUpdateOderItem(item);
            });
          }
        }
      });
    },
    // 提交完成订单（除第三方平台）
    handleChannelWC() {
      // 改订单为12且修改子订单为4
      let data = JSON.parse(JSON.stringify(this.detailsData));
      data.status = 12;
      this.$confirm("请确定是否提前完成该订单服务操作!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.getUpdateOrder(data, false);
        })
        .catch(() => {});
    },
    // 取消返洗订单
    handleChannelQX(){
      // 改订单为13
      let data = JSON.parse(JSON.stringify(this.detailsData));
      data.status = 13
      this.$confirm("请确定是否取消返洗订单!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          updateOrder(data).then(res=>{
            if(res.data.code===200){
              this.detailsData = res.data.data;
              this.$message.success("返洗订单取消成功！");
            }
          })
        })
        .catch(() => {})      
    },
    // 返洗=>先新增订单,此条新增的返洗订单需关联主订单编号orderSn
    // 新增订单后需调用顺丰或者京东下单
    handleBackWash() {
      this.dialogVisibleWashOrder = true;
      console.log("返洗", this.dialogVisibleWashOrder);
    },
    // 子组件传过来的方法刷新数据
    refreshParentOrder(data) {
      this.detailsData = data;
      this.dialogVisibleAddr = false;
      // console.log("data", data);
    },
    // 关闭物流状态弹框
    handleClose(done) {
      this.drawer = false;
    },
    handleCloseQuery() {
      this.drawerQueryMt = false;
    },
    // 物流详情操作
    handleEditLogistic(index, row) {
      console.log(index, row);
    },
    // 点击大图关闭
    closeViewer() {
      this.showViewer = false;
    },
    // 图片点击
    async imgClick(row) {
      await listFile(row.ossFolderName).then(res => {
        let arr = res.data.data;
        this.srcList = [];
        for (let i = 0; i < arr.length; i++) {
          let parts = arr[i].split("?");
          if (parts.length > 1) {
            this.srcList.push(parts[0]);
          }
        }
        this.showViewer = true;
      });
    },
    // 工单编辑操作
    handleEdit(row) {
      this.workDialogVisible = true;
      this.workObj = row;
      console.log("work", this.workObj, this.workDialogVisible);
    },
    isContentShort(str) {
      return str <= 20;
    },
    // 回显分项服务
    getServiceIds(ids) {
      const serviceIds = ids ? ids.split(",").map(Number) : [];
      let filter = this.serviceList.filter(items =>
        serviceIds.includes(items.id)
      );
      console.log("ids", filter, serviceIds);
      return filter;
    },
    mtStatus(v) {
      switch (v) {
        case 1:
          return "待接单";
        case 2:
          return "已接单";
        case 3:
          return "预约失败";
        case 4:
          return "取消中";
        case 5:
          return "已取消";
        case 6:
          return "预约改期中";
        case 7:
          return "商家已服务";
        case 8:
          return "已消费";
        default:
          return "";
      }
    },
    // 美团订单状态
    mtOrderStatus(v) {
      switch (v) {
        case 40001:
          return "已分配";
        case 40101:
          return "已取件";
        case 40002:
          return "已到达";
        case 41101:
          return "清洗中";
        case 41102:
          return "返回中";
        case 41001:
          return "履约完成";
        default:
          return "已接单";
      }
    },
    // 订单状态
    orderStatus(v) {
      //状态:0->已付款；1->待发货；2->已揽件；3->已发货（在途）；4->已收货；5->已入厂;6->已分拣；7->已总检；8->已出厂；9->发回揽件；10->发回（在途）；11->发回收货；12->已完成；13->已取消
      switch (v) {
        case 0:
          return "已付款";
        case 1:
          return "待取件";
        case 2:
          return "已取件(揽件)";
        case 3:
          return "已取件(在途)";
        case 4:
          return "已取件(派送)";
        case 5:
          return "已入厂";
        case 6:
          return "已分检";
        case 7:
          return "已总检";
        case 8:
          return "已出厂";
        case 9:
          return "送件中(揽件)";
        case 10:
          return "送件中(在途)";
        case 11:
          return "送件中(派送)";
        case 12:
          return "已完成";
        case 13:
          return "已取消";
        case 14:
          return "客户取消寄件";
        case 15:
          return "已拒单";
        default:
          return "";
      }
    },
    // 取消
    // toNext() {
    //   this.dialogVisible = false;
    // },
    // 工单类型
    workOrderStatus(v) {
      //类型:1->订单异常；2->售后；3->漏补发；4->催单；5->投诉；6->个人业务；7->疑似丢件；8->退款
      switch (v) {
        case 1:
          return "订单异常";
        case 2:
          return "售后";
        case 3:
          return "漏补发";
        case 4:
          return "催单";
        case 5:
          return "投诉";
        case 6:
          return "个人业务";
        case 7:
          return "疑似丢件";
        case 8:
          return "退款";
        case 9:
          return "数量不符";
        case 10:
          return "补款";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped lang="less">
.orderDetails {
  /deep/ .order-dialog {
    margin-top: 4vh !important;
    border-radius: 10px;
    overflow: hidden;

    .el-dialog__header {
      padding: 16px 24px 12px;
      border-bottom: 1px solid #ebeef5;
      background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
    }

    .el-dialog__body {
      padding: 0;
      max-height: calc(92vh - 60px);
      overflow-y: auto;
      background: #f5f7fa;
    }
  }

  /deep/ .custom-begin-dialog {
    height: 300px !important;
    margin-top: 200px !important;

    .el-dialog__body {
      padding: 10px 25px 0;

      .el-input__inner {
        width: 230px;
      }
    }
  }
}

.order-dialog__title-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.order-dialog__back-icon {
  color: #f56c6c;
  font-size: 20px;
}

.order-dialog__sn {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}

.order-detail-body {
  padding: 16px 20px 20px;
}

.order-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  padding: 14px 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  &__item {
    flex: 1;
    min-width: 120px;
    text-align: center;
    padding: 4px 8px;

    &:not(:last-child) {
      border-right: 1px solid #f0f2f5;
    }
  }

  &__label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 16px;
    font-weight: 600;
    color: #303133;

    &--primary {
      color: #409eff;
      font-size: 18px;
    }
  }
}

.detail-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
}

.detail-section {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  overflow: hidden;

  &--full {
    grid-column: 1 / -1;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #fafbfc;
    border-bottom: 1px solid #f0f2f5;
  }

  &__icon {
    font-size: 16px;
    color: #409eff;

    &--money {
      color: #e6a23c;
    }

    &--logistics {
      color: #67c23a;
    }
  }

  &__title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  &__body {
    padding: 12px 14px;
  }
}

.order-tabs {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 0 12px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }

  /deep/ .el-tabs__item {
    font-weight: 500;
    height: 44px;
    line-height: 44px;
  }

  /deep/ .el-tabs__item.is-active {
    font-weight: 600;
    color: #409eff;
  }
}

.tab-panel {
  padding-top: 12px;

  &__toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 12px;
  }
}

.grillage-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #606266;
  background: #f4f4f5;
  border-radius: 6px;

  &--annex {
    background: #fdf6ec;
    color: #e6a23c;
  }
}

.address-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 16px;
}

.address-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  &__head {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    background: #ecf5ff;

    &--return {
      background: #f0f9eb;
      color: #67c23a;
    }
  }

  &__body {
    padding: 12px 14px;
    font-size: 13px;
    color: #606266;
    line-height: 1.8;

    p {
      margin: 0 0 4px;
    }
  }

  &__label {
    display: inline-block;
    width: 56px;
    color: #909399;
  }

  &__addr {
    margin-top: 6px !important;
    padding-top: 8px;
    border-top: 1px dashed #ebeef5;
    line-height: 1.6 !important;
  }
}

.detail-btn {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 4px;
}

/deep/ .el-image-viewer__wrapper {
  z-index: 9999 !important;
}

/deep/ .el-table__fixed-right::before {
  content: none;
}

/deep/ .el-drawer__body {
  padding-left: 10px;
  padding-top: 10px;
}

.ellipsis {
  max-width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 992px) {
  .detail-cards,
  .address-cards {
    grid-template-columns: 1fr;
  }

  .detail-section--full {
    grid-column: auto;
  }

  .order-summary__item:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid #f0f2f5;
    padding-bottom: 8px;
  }
}
</style>
